import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { Tabs } from '@frontend/design-system';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { ChannelsPanel } from '../../components/sync-engine-release-manager/channels/channels-panel';
import { SourcesPanel } from '../../components/sync-engine-release-manager/sources/sources-panel';
import { TrainsPanel } from '../../components/sync-engine-release-manager/trains/trains-panel';
import { createFileRoute } from '../../utils/route-factory';

enum TabName {
  CHANNELS = 'channels',
  TRAINS = 'trains',
  SOURCES = 'sources',
}

const SyncEngineReleaseManager = () => {
  const canManage = hasSchemaACL('weave', Permission.SYNC_APP_MANAGE_ADVANCED);

  return (
    <Page
      title='Sync Engine Release Manager'
      breadcrumbs={[
        {
          label: 'Global Settings',
          to: '/global-settings',
        },
        {
          label: 'Sync Engine Release Manager',
        },
      ]}
    >
      <Container>
        <Tabs initialTab={TabName.CHANNELS}>
          <Tabs.Bar fullWidth={true}>
            <Tabs.Tab id={TabName.CHANNELS}>Channels</Tabs.Tab>
            <Tabs.Tab id={TabName.TRAINS}>Trains</Tabs.Tab>
            <Tabs.Tab id={TabName.SOURCES}>Sources</Tabs.Tab>
          </Tabs.Bar>
          <Tabs.Panel controller={TabName.CHANNELS}>
            <ChannelsPanel canManage={canManage} />
          </Tabs.Panel>
          <Tabs.Panel controller={TabName.TRAINS} keepMounted={false}>
            <TrainsPanel canManage={canManage} />
          </Tabs.Panel>
          <Tabs.Panel controller={TabName.SOURCES} keepMounted={false}>
            <SourcesPanel canManage={canManage} />
          </Tabs.Panel>
        </Tabs>
      </Container>
    </Page>
  );
};

export const Route = createFileRoute({
  path: '/global-settings/sync-engine-release-manager',
  component: SyncEngineReleaseManager,
  type: 'auth',
});
